<template>
  <div id="SendMessageToAdmin">
    <panel
      class="no-print"
      :Title="pageTitle"
      :Des="pageDescription"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="no-print">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-envelope"></i>
          {{ pageTitle }}
        </h6>
      </template>
      <template slot="content">
        <div class="send-message-form">
          <div class="send-message-fields">
            <div
              class="send-message-field send-message-field--date"
              v-if="isShowDateTimePicker == true"
            >
              <span class="send-message-label">تاریخ حضور</span>
              <date-picker
                :editable="false"
                :auto-submit="true"
                color="#287db4"
                v-model="datetime"
                type="datetime"
              >
              </date-picker>
            </div>
            <label class="send-message-field send-message-field--message">
              <span class="send-message-label">متن پیام خود را بنویسید</span>
              <textarea
                class="form-control send-message-textarea"
                @keypress="$BlockSuspiciousInput($event)"
                @keyup="$BlockSuspiciousInput($event)"
                rows="2"
                ref="textarea"
                @input="adjustHeight"
                v-model="Txt"
                placeholder="پیام خود را بنویسید..."
              >
              </textarea>
            </label>
          </div>
          <div class="send-message-actions">
            <div class="send-message-actions__captcha">
              <CaptchaBox
                ref="captchaRef"
                :width="160"
                :height="40"
                @update="onCaptchaValid"
              ></CaptchaBox>
            </div>
            <button
              class="sv-btn sv-btn--primary sv-btn--wide"
              @click="SendMessage"
              :disabled="!CaptchaValid"
              type="button"
            >
              <i class="fas fa-paper-plane" aria-hidden="true"></i>
              ارسال پیام
            </button>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";

export default {
  data() {
    return {
      datetime: this.$GetJalaliDateTime(),
      Txt: "",
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "InsAzaMessage",
        Token: "",
      },
      CaptchaValid: false,
      captchaText: "",
      captchaId: "",
    };
  },
  components: { NetPaCard, Panel, CaptchaBox },
  computed: {
    pageTitle() {
      return this.$GetIsAnbohSaz()
        ? "فرم ارتباط با مدیر"
        : "فرم درخواست حضوری";
    },
    pageDescription() {
      return this.$GetIsAnbohSaz()
        ? "از طریق این فرم می توانید پیامی در قالب متن را به مدیر سامانه ارسال نمایید."
        : "";
    },
  },
  methods: {
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    SendMessage() {
      if (this.isShowDateTimePicker == true) {
        this.Txt +=
          this.Txt + " \n [ " + " درخواست حضور برای : " + this.datetime + " ] ";
      }
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      formData.append("Message", this.Txt);
      formData.append("ZamanInsert", this.$GetJalaliDateTime());
      formData.append("userInput", this.captchaText);
      formData.append("captchaId", this.captchaId);
      this.DataAxiosRow.ArryfildValue = formData;
      this.DataAxiosRow.Token = this.$session.get("TokenNetPa");
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        console.log(data);
        if (data.status == "NotOk") {
          this.refreshCaptcha();
          this.$mySweetDefault(
            "خطا",
            "کد یکبار مصرف اشتباه است",
            "error",
            3000,
          );
          return;
        }
        if (data.result == "SUCCESS") {
          this.$mySweetDefault(
            "عملیات موفق",
            "ارسال پیام با موفقیت انجام شد",
            "success",
            3000,
          );
          this.Txt = "";
        } else {
          this.$mySweetDefault(
            "خطایی رخ داده است",
            "در ارسال پیام خطایی رخ داده است",
            "error",
            3000,
          );
        }
      });
    },

    adjustHeight() {
      const textarea = this.$refs.textarea;
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    },
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
  },
  props: ["isShowDateTimePicker"],
  created() {
    // console.log(this.isShowDateTimePicker)
  },
};
</script>
<style>
#SendMessageToAdmin {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-blue: #287db4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-shadow-md: 0 8px 18px rgba(41, 52, 95, 0.16);
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);
  --sv-control-h: 40px;
}

#SendMessageToAdmin .netpa-card__header h6 {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0;
  color: #29345f;
  font-size: 15px;
  font-weight: 800;
}

#SendMessageToAdmin .netpa-card__header h6 i {
  color: #56508d;
}

#SendMessageToAdmin .send-message-form {
  padding: 0.35rem 0.5rem 0.35rem;
}

#SendMessageToAdmin .send-message-fields {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

#SendMessageToAdmin .send-message-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin: 0;
}

#SendMessageToAdmin .send-message-field--date {
  max-width: 22rem;
}

#SendMessageToAdmin .send-message-label {
  display: block;
  margin-bottom: 0.35rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25rem;
}

#SendMessageToAdmin .send-message-textarea {
  min-height: 8.5rem;
  padding: 0.7rem 0.85rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.8;
  text-align: right;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  resize: vertical;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#SendMessageToAdmin .send-message-textarea:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

#SendMessageToAdmin .send-message-textarea::placeholder {
  color: #8a96a3;
}

#SendMessageToAdmin .vpd-main {
  display: block;
  width: 100%;
}

#SendMessageToAdmin .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#SendMessageToAdmin .vpd-input-group:focus-within {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#SendMessageToAdmin .vpd-input-group input,
#SendMessageToAdmin .vpd-input-group input.form-control {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
}

#SendMessageToAdmin .vpd-input-group input:focus {
  outline: none;
  box-shadow: none !important;
}

#SendMessageToAdmin .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #287db4;
  border: none;
  background: #edf5fb;
}

#SendMessageToAdmin .send-message-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  width: 100%;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e8eef2;
  box-sizing: border-box;
}

#SendMessageToAdmin .send-message-actions__captcha {
  flex: 0 1 auto;
  min-width: 0;
  margin-left: auto;
}

#SendMessageToAdmin .send-message-actions__captcha .input-group {
  margin-bottom: 0 !important;
  flex-wrap: nowrap !important;
  align-items: stretch;
}

#SendMessageToAdmin .send-message-actions__captcha .form-control {
  height: 44px;
  min-height: 44px;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  border: 1px solid #dbe5eb;
  border-radius: 12px 0 0 12px;
  background: #fff;
}

#SendMessageToAdmin .send-message-actions__captcha .form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#SendMessageToAdmin .send-message-actions__captcha .input-group-text {
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 !important;
  border: 1px solid #dbe5eb;
  border-right: 0;
  border-radius: 0 12px 12px 0;
  background: #fff;
}

#SendMessageToAdmin .send-message-actions__captcha .input-group-text img {
  height: 44px;
  width: auto;
}

#SendMessageToAdmin .sv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: var(--sv-control-h);
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  border-radius: 12px;
  cursor: pointer;
  transition:
    color var(--bnp-motion-fast) var(--bnp-ease-standard),
    background var(--bnp-motion-fast) var(--bnp-ease-standard),
    border-color var(--bnp-motion-fast) var(--bnp-ease-standard),
    box-shadow var(--bnp-motion-fast) var(--bnp-ease-standard),
    transform var(--bnp-motion-fast) var(--bnp-ease-standard);
}

#SendMessageToAdmin .sv-btn:focus {
  outline: none;
}

#SendMessageToAdmin .sv-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

#SendMessageToAdmin .sv-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

#SendMessageToAdmin .sv-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
  box-shadow: var(--bnp-shadow-md);
}

#SendMessageToAdmin .sv-btn--primary:not(:disabled):hover {
  color: #fff;
  transform: translateY(-1px);
}

#SendMessageToAdmin .sv-btn--wide {
  min-width: 168px;
  min-height: 44px;
}

@media (max-width: 575px) {
  #SendMessageToAdmin .send-message-field--date {
    max-width: none;
  }

  #SendMessageToAdmin .send-message-actions {
    flex-direction: column;
    align-items: stretch;
  }

  #SendMessageToAdmin .send-message-actions__captcha {
    flex: none;
    width: 100%;
    margin-left: 0;
  }

  #SendMessageToAdmin .sv-btn--wide {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  #SendMessageToAdmin .sv-btn {
    transition: none;
  }

  #SendMessageToAdmin .sv-btn--primary:not(:disabled):hover {
    transform: none;
  }
}
</style>
